import axios from "axios";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "https://mobileapp.ubt.edu.sa/UBT.API.PROD/api",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false, // Ensure this is false unless using authentication
});

// ✅ Log request/response status for debugging (no sensitive data)
apiClient.interceptors.request.use((request) => {
  console.log("🔵 Axios Request:", request);
  return request;
});

apiClient.interceptors.response.use(
  (response) => {
    console.log("🟢 Axios Response:", response);
    return response;
  },
  (error) => {
    console.error("🔴 Axios Error:", error);
    return Promise.reject(error);
  }
);

export default apiClient;
